export default "__VITE_ASSET__BBsBM5VY__"